import { render } from "./Catalog.vue?vue&type=template&id=f68a543a&scoped=true"
import script from "./Catalog.vue?vue&type=script&lang=js"
export * from "./Catalog.vue?vue&type=script&lang=js"

import "./Catalog.vue?vue&type=style&index=0&id=f68a543a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-f68a543a"

export default script